export default function About() {
  return (
    <section id="about" className="py-16 md:py-32 bg-[#F8F6F3]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="order-2 lg:order-1">
            <div className="text-[#2563EB] text-sm font-bold uppercase tracking-wider mb-4">
              • ABOUT US
            </div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Expert Craftsmanship<br />
              You Can Trust
            </h2>
            <p className="text-base md:text-lg text-gray-600 mb-6 leading-relaxed">
              With over 3 years of experience and 70+ completed projects in Winter Garden and surrounding areas, BestCall Restor has become the go-to choice for homeowners seeking quality remodeling services.
            </p>
            <p className="text-base md:text-lg text-gray-600 mb-8 leading-relaxed">
              Our team of skilled craftsmen takes pride in every project, ensuring meticulous attention to detail and superior workmanship. From concept to completion, we're committed to bringing your vision to life.
            </p>
            
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div>
                <div className="text-3xl md:text-4xl font-bold text-[#2563EB] mb-2">70+</div>
                <div className="text-sm text-gray-600">Completed Projects</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-[#2563EB] mb-2">100%</div>
                <div className="text-sm text-gray-600">Client Satisfaction</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-[#2563EB] mb-2">3+</div>
                <div className="text-sm text-gray-600">Years Experience</div>
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-[#2563EB] mb-2">5★</div>
                <div className="text-sm text-gray-600">Average Rating</div>
              </div>
            </div>

            <a 
              href="#contact" 
              className="inline-flex items-center gap-3 bg-[#2563EB] hover:bg-[#1D4ED8] text-white px-8 py-4 rounded-lg text-base font-semibold transition-all duration-300 hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Get Started Today
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>

          <div className="order-1 lg:order-2">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="rounded-2xl overflow-hidden shadow-lg h-48 sm:h-56 md:h-64">
                  <img
                    src="https://public.readdy.ai/ai/img_res/ac1d334ebc930ca7c56d99874693b695.jpg"
                    alt="Professional Craftsman"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg h-56 sm:h-64 md:h-80">
                  <img
                    src="https://readdy.ai/api/search-image?query=modern%20renovated%20bathroom%20with%20white%20subway%20tiles%20chrome%20fixtures%20clean%20design%20professional%20remodeling%20work%20elegant%20vanity%20mirror%20bright%20lighting%20simple%20white%20wall%20background%20contemporary%20bathroom%20design%20high%20end%20finish&width=400&height=600&seq=about-img-2&orientation=portrait"
                    alt="Bathroom Remodeling"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="rounded-2xl overflow-hidden shadow-lg h-56 sm:h-64 md:h-80">
                  <img
                    src="https://readdy.ai/api/search-image?query=beautiful%20modern%20kitchen%20remodel%20with%20white%20cabinets%20marble%20countertops%20stainless%20steel%20appliances%20professional%20installation%20clean%20design%20bright%20natural%20lighting%20simple%20white%20wall%20background%20luxury%20kitchen%20renovation%20high%20quality%20finish&width=400&height=600&seq=about-img-3&orientation=portrait"
                    alt="Kitchen Remodeling"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="rounded-2xl overflow-hidden shadow-lg h-48 sm:h-56 md:h-64">
                  <img
                    src="https://readdy.ai/api/search-image?query=worker%20painting%20interior%20wall%20with%20roller%20clean%20white%20painted%20walls%20professional%20painting%20service%20smooth%20finish%20quality%20workmanship%20simple%20white%20background%20residential%20painting%20project&width=400&height=500&seq=about-img-4&orientation=portrait"
                    alt="Interior Painting"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}